<fieldset class="ais-RefinementList">
  <!-- this div is here to simulate the ng-ais-header container -->
  <div>
    <button
      class="ais-RefinementList-header ais-header"
      [ngClass]="{'ais-RefinementList-header--closed': !showRefinementBody}"
      (click)="toggleShowBody()"
      [attr.aria-expanded]="showRefinementBody"
    >
      <legend i18n="@@CATALOG.FILTERS.LOCATION">Shipped from</legend>
    </button>
  </div>

  <!-- Refinement body -->
  <div class="ais-RefinementList-body ais-body" [ngStyle]="{display: showRefinementBody ? 'block' : 'none'}">
    <input
      *ngIf="items?.length > limitToDisplaySearch"
      [formControl]="searchLocationInput"
      [value]="searchText"
      (input)="searchText = $event.target.value"
      type="text"
      class="vc-form-text2__input filters__checkboxList__search"
      i18n-placeholder="@@CATALOG.FILTERS.SEARCH_PLACEHOLDER.LOCATION"
      placeholder="Enter your country"
    />
    <ul
      class="ais-RefinementList-list"
      [ngClass]="{filters__checkboxList__scroll: items.length > 10 && !options.showMoreLimit}"
    >
      <li *ngFor="let item of items | filter: {inputText: searchText, key: 'label'}; let index = index">
        <ng-container *ngIf="item.url; else label">
          <!-- SSR Case -->
          <span class="vc-checkbox__label filters_checkbox_label">
            <a href="{{ item.url }}"> <ng-container *ngTemplateOutlet="innerLabel"></ng-container> </a>
            <span class="filters_checkbox_label_count">({{ item.count }})</span>
          </span>
        </ng-container>

        <ng-template #label>
          <!-- Browser case -->
          <input
            id="{{ options.facet }}__{{ item.id || index }}"
            class="vc-checkbox__input filters_checkbox_input"
            type="checkbox"
            (change)="refine($event, item)"
            [attr.checked]="item.isRefined ? 'checked' : null"
          />
          <label for="{{ options.facet }}__{{ item.id || index }}" class="vc-checkbox__label filters_checkbox_label">
            <ng-container *ngTemplateOutlet="innerLabel"></ng-container>
            <span class="filters_checkbox_label_count">({{ item.count }})</span>
          </label>
        </ng-template>

        <!--
          ITEM LABEL
          This is the tempalte that'll be inserted in the <*ngTemplateOutlet="innerLabel"> placeholders
        -->
        <ng-template #innerLabel>
          <ng-container>{{ item.label }}</ng-container>
        </ng-template>
      </li>
    </ul>
    <vc-show-more-button
      *ngIf="options.showMoreLimit && state.canToggleShowMore"
      [isShowingMore]="state?.isShowingMore"
      (toggleShowMore)="state.toggleShowMore()"
    ></vc-show-more-button>
  </div>
</fieldset>
